/**
 * 全局配置文件
 * 用于存储网站的可维护内容，如导航菜单、联系方式、公司信息等
 */

// 公司基础信息
export const companyInfo = {
  name: "江苏智先生信息科技有限公司",
  phone: "400-888-0120",
  qq: "1341686309",
  email: "service@zxstech.com",
  icp: "苏ICP备19023016号-1",
  addresses: [
    "徐州市云龙区普陀路招商淮海金融大厦12层",
    "南京市鼓楼区北京西路5号中江国际1号4楼",
    // "盐城市盐南高新区科城街道大数据北区A1幢北楼10层",
    // "淮安市经济技术开发区枚皋路19号淮安智慧谷B3楼312室",
  ],
};

// 导航菜单配置
export const navMenus = {
    // 智慧运营
  operate: {
    name: "智慧运营",
    items: [
      { name: "智慧运营管理平台", path: "/operate" },
    ],
  },

  // 智能运维产品线
  smart: {
    name: "智能运维",
    items: [
      { name: "数字化运维监控系统", path: "/smart" },
      { name: "IT服务流程管理系统", path: "/it-service" },
      { name: "数字网信管理系统", path: "/digital-management" },
      { name: "数据资产应用管理系统", path: "/data-management" },
    ],
  },
  // 智慧医保产品线
  medical: {
    name: "智慧医保",
    items: [
      { name: "医保基金智能监管系统", path: "/medical" },
      { name: "医保结算清单质控系统", path: "/medical-control" },
      { name: "DRG/DIP院内综合管理平台", path: "/drg-platform" },
      { name: "门诊APG管理系统", path: "/apg-management" },
      { name: "合理诊疗智慧监管系统", path: "/reasonable-treatment" },
      // { name: '互联网医院', path: '/internet-hospital' }
    ],
  },
  // 智慧服务产品线
  serve: {
    name: "智慧服务",
    items: [
      { name: "互联网医院", path: "/internet-hospital" },
      { name: "统一预约平台", path: "/reserve" },
      { name: "远程医疗系统", path: "/remote-medical" },
      { name: "患者就医全流程消息指引系统", path: "/guild" },
      { name: "统一支付对账平台", path: "/pay-check" },
      { name: "患者诊后健康管理平台", path: "/health" },
    ],
  },
  // 独立菜单项
  standalone: [
    { name: "培训认证", path: "/training" },
    { name: "新闻中心", path: "/news" },
    { name: "关于我们", path: "/about" },
    { name: "加入我们", path: "/join" },
    { name: "免费试用", path: "/free" },
  ],
};

// Footer 快速入口配置
export const footerMenus = {
  about: {
    title: "关于我们",
    items: [
      { name: "企业简介", path: "/about" },
      { name: "用户案例", path: "/about#partners" },
      { name: "发展历程", path: "/about#history" },
    ],
  },
  smart: {
    title: "智能运维",
    items: navMenus.smart.items,
  },
  medical: {
    title: "智慧医保",
    items: navMenus.medical.items,
  },
  serve: {
    title: "智慧服务",
    items: navMenus.serve.items,
  },
  quickEntry: {
    title: "快速入口",
    items: [
      { name: "新闻中心", path: "/news" },
      { name: "行业动态", path: "/news#3" },
      { name: "加入我们", path: "/join" },
      { name: "免费试用", path: "/free" },
    ],
  },
};

// 样式相关配置
export const styles = {
  // 主题色
  themeColors: {
    primary: "#1CB3B8",
    secondary: "#386FC6",
    text: "#1f2329",
    textLight: "#50627f",
    gray: "#929EB0",
  },
  // 头部高度
  headerHeight: {
    desktop: 64,
    mobile: 50,
  },
};
